import * as React from "react";

import { ReactComponent as DirectboxReceiveIcon } from "assets/images/svg/directbox-receive.svg";

import styles from "./AttractorDetailsEmpty.module.scss";

export const AttractorDetailsEmpty: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <DirectboxReceiveIcon />
      </div>
      <div className={styles.title}>Пользователь пока не выбран</div>
      <div className={styles.description}>
        Нажмите на одного из пользователей чтобы узнать подробности
      </div>
    </div>
  );
};
